import { createFileRoute } from '@tanstack/react-router'
import { ResellerBillingPage } from '@/features/reseller/pages/billing'

export const Route = createFileRoute('/_authenticated/reseller/billing')({
  component: ResellerBillingPage,
})

